import React from 'react';

// The Account and Settings pages share one shape: sections, each with a title and a short
// description, divided by a rule. `first` has no rule above it; `danger` is Delete account.
const RULE = '#94a3b8';
const DANGER_RULE = '#f87171';

export function PageSection({ title, description, first = false, danger = false, children, ...rest }) {
  return (
    <section aria-label={title} {...rest} style={{
      marginTop: first ? 0 : 30, paddingTop: first ? 0 : 22,
      borderTop: first ? 'none' : `1px solid ${danger ? DANGER_RULE : RULE}`,
    }}>
      <h2 style={{ fontSize: '1.05rem', fontWeight: 700, margin: 0, color: danger ? '#b91c1c' : '#1a1a2e' }}>{title}</h2>
      <p style={{ color: '#64748b', fontSize: '0.85rem', margin: '4px 0 14px', maxWidth: 480 }}>
        {description}
      </p>
      {children}
    </section>
  );
}

// One setting inside a section: a plain (not bold) label, an optional line of help, and its
// input indented under them.
export function Control({ label, help, children, style }) {
  return (
    <div style={{ margin: '0 0 18px', ...style }}>
      <div style={{ fontSize: '0.95rem', color: '#1e293b' }}>{label}</div>
      {help && <div style={{ color: '#64748b', fontSize: '0.8rem', marginTop: 2 }}>{help}</div>}
      <div style={{ marginTop: 8, paddingLeft: 20 }}>{children}</div>
    </div>
  );
}

// The app's on/off control. A real checkbox underneath (so labels, forms, keyboard and
// `data-input` readers keep working), drawn as a switch by `.aveq-toggle` in index.css.
export function Toggle({ className = '', ...props }) {
  return <input type="checkbox" role="switch" className={`aveq-toggle ${className}`.trim()} {...props} />;
}

// A toggle with its label (and optional help) on one row.
export function ToggleRow({ label, help, checked, onChange, disabled, style, ...rest }) {
  return (
    <label style={{ display: 'flex', alignItems: 'flex-start', gap: 12, cursor: disabled ? 'default' : 'pointer',
                    maxWidth: 480, ...style }}>
      <Toggle checked={checked} disabled={disabled} onChange={onChange} {...rest} style={{ marginTop: 1 }} />
      <span>
        <span style={{ fontSize: '0.9rem', color: '#1e293b' }}>{label}</span>
        {help && <span style={{ display: 'block', color: '#64748b', fontSize: '0.8rem', marginTop: 2 }}>{help}</span>}
      </span>
    </label>
  );
}
